import { Button } from '@src/components/Button';
import { ErrorHandler } from '@src/components/ErrorHandler';
import { Visibility } from '@src/features/Users/components/Visibility';
import { IsEndDatePresent } from '@src/includes/functions';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { motion } from 'framer-motion';
import { isEmpty, isUndefined } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { WithToolTip } from './components/WithToolTip';

/**
 * Button: ConfComm
 *
 * Button to add a Confidential Communications address.
 *
 * @returns {Element}
 * @constructor
 */
export function ConfComm(props) {
  const { additionalAddresses, onClick } = props;

  const [isDisabled, setIsDisabled] = useState(false);

  /**
   * Check if the button should be disabled.
   */
  useEffect(() => {
    if (!isUndefined(additionalAddresses) && !isEmpty(additionalAddresses)) {
      setIsDisabled(IsEndDatePresent(additionalAddresses, 'CONF_COMM'));
    }
  }, [additionalAddresses]);

  return (
    <ErrorHandler location="src/routes/private/MemberProfile/components/Buttons/ConfComm/Button.jsx">
      <Visibility accessor="ConfCommButton" enabledUserRoles={['State.Type.ConfComm.Write']}>
        <motion.div
          animate="open"
          initial={{ opacity: 0 }}
          variants={{
            closed: { opacity: 0 },
            open: { opacity: 1 },
          }}
        >
          <WithToolTip status={isDisabled}>
            <Button
              aria-haspopup="dialog"
              css={{ marginRight: 'var(--abyss-space-sm)' }}
              isDisabled={isDisabled}
              onClick={onClick}
              variant="solid"
            >
              <IconSymbol css={{ marginRight: 'var(--abyss-space-sm)' }} icon="add_circle" size="18px" /> Conf Comm
              Address
            </Button>
          </WithToolTip>
        </motion.div>
      </Visibility>
    </ErrorHandler>
  );
}

ConfComm.propTypes = {
  additionalAddresses: PropTypes.arrayOf(
    PropTypes.shape({
      addressType: PropTypes.string,
      endDate: PropTypes.string,
    })
  ),
  onClick: PropTypes.func,
};

ConfComm.defaultProps = {
  additionalAddresses: [],
  onClick: () => {},
};
